import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay, Navigation, Mousewheel, Parallax } from 'swiper/modules';

export class Gallery extends AbstractComponent {
  init() {
    let options = this.el.dataset.sliderOptions ? JSON.parse(this.el.dataset.sliderOptions) : {};
    const speed = this.el.dataset.speed ? this.el.dataset.speed : 3;

    const el = this.el
    const slidesCount = el.querySelectorAll('.swiper-slide').length;
    const captions = el.querySelectorAll('[data-caption]');
    const isSlideshow = el.classList.contains('is-slideshow');

    const slideshowOptions = isSlideshow ? {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      parallax: false,
      loop: slidesCount > 1,
      fadeEffect: {
        crossFade: true,
      },
      autoplay: false
    } : {}

    if (speed) {
      options['autoplay'] = Number(speed) ? {
        delay: Number(speed) * 1000,
      } : false;
    }

    this.swiper = new Swiper(el, {
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 15,
      modules: [EffectFade, Pagination, Autoplay, Navigation, Mousewheel, Parallax],
      loop: slidesCount > 3,
      speed: 700,
      parallax: true,
      effect: 'slide',
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: isSlideshow ? 1: 1.4,
          spaceBetween: 25,
        },
      },
      autoplay: {
        delay: 3000,
      },
      navigation: {
        nextEl: ".is-next",
        prevEl: ".is-prev",
      },
      pagination: {
        el: "[data-pagination]",
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}"><span>${captions[index].innerText}</span><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4.5" stroke="currentColor"/><circle cx="5.00313" cy="4.99922" r="1.8" fill="currentColor"/></svg></span>`;
        }
      },
      on: {
        autoplayTimeLeft: (swiper, timeLeft, percentage) => {
          this.el.style.setProperty('--progress', String(1 - percentage));
        },
        slideChange: (swiper) => {
          this.el.style.setProperty('--index', String(swiper.realIndex));
        },
      },
      ...options,
      ...slideshowOptions
    });

    setTimeout(() => {
      this.swiper.update()
    }, 1000)
  }
}

register('gallery', Gallery);
